export const BRAND = {
  primary: "#1D4E89",
  primaryDark: "#153A66",
  primaryLight: "#E8F1FA",
  accent: "#F37021",
  accentGreen: "#4CAF50",
};

export const ACTIVE_BUTTON_STYLE = {
  background: BRAND.primary,
  border: "none",
  borderRadius: "0.625rem",
  color: "#ffffff",
  fontWeight: 600,
};

export const ACCENT_BUTTON_STYLE = {
  background: BRAND.accent,
  border: "none",
  borderRadius: "0.625rem",
  color: "#ffffff",
  fontWeight: 600,
};

export const CANCEL_OPT_OUT_BUTTON_STYLE = {
  background: "#DC2626",
  border: "none",
  borderRadius: "0.625rem",
  color: "#ffffff",
  fontWeight: 600,
};

export const formatCurrency = (value, { decimals = 0 } = {}) => {
  const num = Number(value || 0);
  return `₹${num.toLocaleString("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
};

export const capitalize = (value) =>
  String(value || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const getStoredUser = () => {
  try {
    const raw = sessionStorage.getItem("authUser");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const buildReferralLink = (referralNumber) => {
  if (!referralNumber) return "";
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}/register?referral_number=${encodeURIComponent(referralNumber)}`;
};
